import { Button, CircularProgress } from '@mui/material';
import React from 'react';

type SendCodeProps = {
  disabled: boolean;
  phone: string;
  sendCode: () => void;
};

const SendCode: React.FC<SendCodeProps> = ({ disabled, phone, sendCode }) => {
  return (
    <Button
      type="button"
      variant="contained"
      color="primary"
      fullWidth
      sx={{ mt: 2 }}
      disabled={disabled}
      onClick={sendCode}
    >
      {disabled ? <CircularProgress size={24} /> : `Send code to ${phone}`}
    </Button>
  );
};

export default SendCode;
